var menuBtn = {
  // btn01用のオブジェクト

  init:function () {
    this.btn();
  },

  btn: function() {
    var $btn = $('#menu-trigger');
    $btn.on('click',function(){
      $(this).toggleClass('active');
      $('.c-gnav').toggleClass('active');
      $('body').toggleClass('active');
    });
  }

};



module.exports = menuBtn;


//////////////////
// WEBPACK FOOTER
// ./htdocs_dev/_script/components/pagemodules/_menuBtn.js
// module id = 5
// module chunks = 0